<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">Limited Partners
                <span class="card-subtitle" v-if="investor.name">{{investor.name}} ({{investor.cp_email}})</span>
                <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/investors')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">{{trans('investor.investor_list')}}</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <investor-sidebar menu="basic" :id="id"></investor-sidebar>
                                <div class="col-9 col-sm-9">
                                    <h4 class="card-title">{{trans('investor.basic')}}</h4>
                                    <form @submit.prevent="submit" @keydown="investorForm.errors.clear($event.target.name)">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <div class="row">
                                                  <div class="col-12 col-sm-12">
                                                    <div class="form-group">
                                                      <label for="">{{trans('investor.name')}}</label>
                                                      <input class="form-control" type="text" value="" v-model="investorForm.name" name="name" :placeholder="trans('investor.name')">
                                                      <show-error :form-name="investorForm" prop-name="name"></show-error>
                                                    </div>
                                                  </div>
                                                  <!--  <div class="col-12 col-sm-6">
                                                        <div class="form-group">
                                                            <label for="">{{trans('investor.first_name')}}</label>
                                                            <input class="form-control" type="text" value="" v-model="investorForm.cp_first_name" name="cp_first_name" :placeholder="trans('investor.first_name')">
                                                            <show-error :form-name="investorForm" prop-name="cp_first_name"></show-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                        <div class="form-group">
                                                            <label for="">{{trans('investor.last_name')}}</label>
                                                            <input class="form-control" type="text" value="" v-model="investorForm.cp_last_name" name="cp_last_name" :placeholder="trans('investor.last_name')">
                                                            <show-error :form-name="investorForm" prop-name="cp_last_name"></show-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                        <div class="form-group">
                                                            <label for="">{{trans('investor.email')}}</label>
                                                            <input class="form-control" type="text" value="" v-model="investorForm.cp_email" name="cp_email" :placeholder="trans('investor.email')" readonly>
                                                            <show-error :form-name="investorForm" prop-name="cp_email"></show-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group">
                                                        <label for="">{{trans('investor.phone')}}</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.cp_phone" name="cp_phone" readonly>
                                                        <show-error :form-name="investorForm" prop-name="cp_phone"></show-error>
                                                      </div>
                                                    </div>-->
                                                </div>
<hr />

                                              <div class="row">
                                                <div class="col-12 col-sm-12">
                                                  <div class="row">
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Active</label>
                                                        <select class="form-control" v-model="investorForm.active" name="active">
                                                          <option value="">Not available</option>
                                                          <option value="Yes">Yes</option>
                                                          <option value="No">No</option>
                                                        </select>
                                                        <!-- <input class="form-control" type="text" value="" v-model="investorForm.active" name="active" :placeholder="trans('transcript.active')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Label</label>
                                                        <select class="form-control" v-model="investorForm.label" name="active">
                                                          <option value="">None</option>
                                                          <option v-for="(label, index) in labels" :key="label.name">
                                                            {{ label.name }}
                                                          </option>
                                                        </select>
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Website</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.website" name="website" :placeholder="trans('transcript.active')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">ESG Status</label>
                                                        <select class="form-control" v-model="investorForm.esg_status" name="esg_status">
                                                          <option value="">Not available</option>
                                                          <option value="Yes">Yes</option>
                                                          <option value="No">No</option>
                                                        </select>
                                                        <!-- <input class="form-control" type="text" value="" v-model="investorForm.esg_status" name="esg" :placeholder="trans('transcript.esg')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Open to First-Time Funds</label>
                                                        <select class="form-control" v-model="investorForm.open_to_first_time_funds" name="open_to_first_time_funds">
                                                          <option value="">Not available</option>
                                                          <option value="Yes">Yes</option>
                                                          <option value="No">No</option>
                                                        </select>
                                                       <!-- <input class="form-control" type="text" value="" v-model="investorForm.open_to_first_time_funds" name="fund_first_time" :placeholder="trans('transcript.fund_first_time')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Holding Period</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.holding_period" name="holding_period" :placeholder="trans('transcript.holding_period')">

                                                      </div>
                                                    </div>
                                                    <!--    <div class="col-12 col-sm-6">
                                                          <div class="form-group" style="margin-bottom: 52px;">
                                                            <label for="">Ticket Size</label>
                                                            <input class="form-control" type="text" value="" v-model="investorForm.ticket_size" name="ticket_size" :placeholder="trans('transcript.ticket_size')">
                                                          </div>
                                                        </div> -->
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Preferred Fund Type (Asset Classes)</label>
                                                        <!-- <v-select v-if="selected_preferred_fund_type_organization" :disabled="true" label="name" track-by="id" v-model="selected_preferred_fund_type_organization" name="preferred_fund_type_organization_id" id="preferred_fund_type_organization_id" :options="fund_types" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" :selected="selected_preferred_fund_type_organization"></v-select> -->
                                                        <!-- <input class="form-control" type="text" value="" v-model="investorForm.preferred_fund_type_organization" name="preferred_fund_type_organization" :placeholder="trans('transcript.preferred_fund_type')"> -->
                                                        <v-select label="name" track-by="name" v-model="selected_preferred_fund_type_organizations" name="preferred_fund_type_organization" id="preferred_fund_type_organization" :options="investor_preferred_fund_types" :placeholder="'Please choose'" @select="onInvestorPreferredFundTypeSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onInvestorPreferredFundTypeRemove" :selected="selected_preferred_fund_type_organizations"></v-select>

                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Preferred Geography</label>
                                                        <!-- <v-select :disabled="true" label="name" track-by="id" v-model="selected_preferred_geography" name="preferred_fund_type_organization_id" id="preferred_fund_type_organization_id" :options="countries" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" :selected="selected_preferred_geography"></v-select> -->
                                                        <v-select label="name" track-by="name" v-model="selected_preferred_geographies" name="preferred_geography" id="preferred_geography" :options="countries" :placeholder="'Please choose'" @select="onPreferredGeographySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onPreferredGeographyRemove" :selected="selected_preferred_geographies"></v-select>
                                                       <!-- <input class="form-control" type="text" value="" v-model="investorForm.preferred_geography" name="preferred_geography" :placeholder="trans('transcript.preferred_geography')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Description</label>
                                                        <textarea class="form-control" style="height:80px;" v-model="investorForm.description" name="description"></textarea>

                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Policy Description</label>
                                                        <textarea class="form-control" style="height:80px;" v-model="investorForm.policy_description" name="policy_description"></textarea>
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Limited Partner Type (Investor Type)</label>
                                                        <v-select label="name" track-by="name" v-model="selected_limited_partner_type_organizations" name="limited_partner_type_organization" id="limited_partner_type_organization" :options="limited_partner_type_organizations" :placeholder="'Please choose'" @select="onLimitedPartnerTypeOrganizationSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onLimitedPartnerTypeOrganizationRemove" :selected="selected_limited_partner_type_organizations"></v-select>
                                                        <!-- <input class="form-control" type="text" value="" v-model="investorForm.limited_partner_type_organization" name="partner_type" :placeholder="trans('transcript.partner_type')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Investment Structure</label>
                                                        <v-select label="name" track-by="name" v-model="selected_investment_structures" name="investment_structure" id="investment_structure" :options="investment_structures" :placeholder="'Please choose'" @select="onInvestmentStructureSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onInvestmentStructureRemove" :selected="selected_investment_structures"></v-select>
                                                        <!-- <input class="form-control" type="text" value="" v-model="investorForm.investment_structure" name="inv_struct" :placeholder="trans('transcript.inv_struct')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Preferred Commitment Size (USD MN)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.preferred_commitment_size" name="preferred_commitment_size" :placeholder="trans('transcript.preferred_commitment_size')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Commitments</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.commitments" name="commitments" :placeholder="trans('transcript.commitments')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Commitments in RE Funds</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.commitments_in_re_funds" name="commitments_re" :placeholder="trans('transcript.commitments_re')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Commitments in VC Funds</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.commitments_in_vc_funds" name="commitments_vc" :placeholder="trans('transcript.commitments_vc')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Commitments in Infrastructure</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.commitments_in_infrastructure" name="commitments_inv" :placeholder="trans('transcript.commitments_inv')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Commitments in PE Funds</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.commitments_in_pe_funds" name="commitments_pe" :placeholder="trans('transcript.commitments_pe')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Alternative Investments (%)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.alternative_investments_perc" name="inv_alt" :placeholder="trans('transcript.inv_alt')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Real Estate (%)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.real_estate_perc" name="real_estate_perc" :placeholder="trans('transcript.real_estate_perc')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Private Equity (%)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.private_equity_perc" name="private_equity_perc" :placeholder="trans('transcript.private_equity_perc')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Alternative Investments (USD MN)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.alternative_investments_amn" name="alternative_investments" :placeholder="trans('transcript.alternative_investments')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Real Estate (USD MN)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.real_estate_amn" name="real_estate_amount" :placeholder="trans('transcript.real_estate_amount')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Private Equity (USD MN)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.private_equity_amn" name="private_equity_amount" :placeholder="trans('transcript.private_equity_amount')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Number of employees</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.number_of_employees" name="number_of_employees" :placeholder="trans('transcript.number_of_employees')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">IRR %</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.irr_perc" name="irr" :placeholder="trans('transcript.irr')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Equity Multiple / MOIC (x)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.moic" name="moic" :placeholder="trans('transcript.moic')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Fund Status</label>
                                                        <select class="form-control" v-model="investorForm.fund_status" name="fund_status">
                                                          <option value="">Not available</option>
                                                          <option value="Closed Ended">Closed Ended</option>
                                                          <option value="Open Ended">Open Ended</option>
                                                        </select>
                                                        <!-- <input class="form-control" type="text" value="" v-model="investorForm.fund_status" name="fund_status" :placeholder="trans('transcript.fund_status')"> -->
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">Assets Under Management (AUM) (USD MN)</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.assets_under_management" name="assets_amount" :placeholder="trans('transcript.assets_amount')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">HQ City</label>
                                                        <input class="form-control" type="text" value="" v-model="investorForm.hq_city" name="hq_city" :placeholder="trans('transcript.hq_city')">
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">HQ Country</label>
                                                        <v-select label="name" track-by="name" v-model="selected_hq_countries" name="hq_country" id="hq_country" :options="countries" :placeholder="'Please choose'" @select="onHQCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQCountryRemove" :selected="selected_hq_countries"></v-select>
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group" style="margin-bottom: 52px;">
                                                        <label for="">HQ Global Sub Region</label>
                                                        <v-select label="name" track-by="name" v-model="selected_hq_global_sub_regions" name="hq_global_sub_region" id="hq_global_sub_region" :options="regions" :placeholder="'Please choose'" @select="onHQGlobalSubRegionSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQGlobalSubRegionRemove" :selected="selected_hq_global_sub_regions"></v-select>
                                                      </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group">
                                                        <label for="">HQ Global Region</label>
                                                        <v-select label="name" track-by="name" v-model="selected_hq_global_regions" name="hq_global_region" id="hq_global_region" :options="continents" :placeholder="'Please choose'" @select="onHQGlobalRegionSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQGlobalRegionRemove" :selected="selected_hq_global_regions"></v-select>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn btn-sm btn-info pull-right">{{trans('general.save')}}</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import investorSidebar from './investor-sidebar'
    import vSelect from 'vue-multiselect'

    export default {
        components : { investorSidebar,vSelect},
        data() {
            return {
                id:this.$route.params.id,
                investorForm: new Form({
                    name: '',
                    label: '',
                    website: '',
                    holding_period:'',
                    cp_first_name: '',
                    cp_last_name: '',
                    cp_email: '',
                    cp_phone: '',
                    policy_description:'',
                    fundtype: '',
                    geography: '',
                    hqcity: '',
                    hqcontinent: '',
                    hqcountry: '',
                    invstructure: '',
                    irr: '',
                    moic: '',
                    period: '',
                    description: '',
                    ticketsize: '',
                    preferred_fund_type: '',
                    preferred_geography: [],
                    active: '',
                    partner_type:'',
                    inv_struct:'',
                    limited_partner_type_organization: [],
                    investment_structure: [],
                    open_to_first_time_funds: '',
                    preferred_commitment_size: '',
                    commitments: '',
                    commitments_in_re_funds: '',
                    commitments_in_vc_funds: '',
                    commitments_in_infrastructure: '',
                    commitments_in_pe_funds: '',
                    alternative_investments_perc: '',
                    real_estate_perc: '',
                    private_equity_perc: '',
                    alternative_investments_amn: '',
                    real_estate_amn: '',
                    private_equity_amn: '',
                    number_of_employees: '',
                    irr_perc: '',
                    preferred_fund_type_organization: [],
                    fund_status: '',
                    esg_status: '',
                    assets_under_management: '',
                    hq_city: '',
                    hq_country: [],
                    hq_global_sub_region: [],
                    hq_global_region: [],
                },false),
                investor: '',
                fund_categories: '',
                fund_types: '',
                selected_hq_global_regions: [],
                continents: [],
                hq_global_region: [],
                selected_hq_countries: [],
                countries: [],
                hq_country: [],
                regions: [],
                selected_hq_global_sub_regions: [],
                hq_global_sub_region: [],
                currencies: '',
                investor_preferred_fund_types: [],
                preferred_fund_type_organization: [],
                selected_preferred_fund_type_organizations: [],
                selected_preferred_geographies:[],
                preferred_geography: [],
                preferred_geographies: [],
                investment_structure: [],
                selected_investment_structures: [],
                limited_partner_type_organization: [],
                selected_limited_partner_type_organizations: [],
                limited_partner_type_organizations: [
                  {
                    id: 1,
                    name: "Foundation"
                  },
                  {
                    id: 2,
                    name: "Government Agency"
                  },
                  {
                    id: 3,
                    name: "Insurance Company"
                  },
                  {
                    id: 4,
                    name: "Public Pension Fund"
                  },
                  {
                    id: 5,
                    name: "Sovereign Wealth Fund"
                  },
                  {
                    id: 6,
                    name: "Banking Institution"
                  },
                  {
                    id: 7,
                    name: "Corporate Pension"
                  },
                  {
                    id: 8,
                    name: "Corporation"
                  },
                  {
                    id: 9,
                    name: "Direct Investment"
                  },
                  {
                    id: 10,
                    name: "Endowment"
                  },
                  {
                    id: 11,
                    name: "Fund of Funds"
                  },
                  {
                    id: 12,
                    name: "Investment Advisor"
                  },
                  {
                    id: 13,
                    name: "Money Management Firm"
                  },
                  {
                    id: 14,
                    name: "Private Investment Fund"
                  },
                  {
                    id: 15,
                    name: "Wealth Management Firm"
                  },
                  {
                    id: 16,
                    name: "Family Office (Multi)"
                  },
                  {
                    id: 17,
                    name: "Economic Development Agency"
                  },
                  {
                    id: 18,
                    name: "Mutual Fund Company"
                  },
                  {
                    id: 19,
                    name: "Real Estate Investment Company"
                  },
                  {
                    id: 20,
                    name: "Secondary LP"
                  },
                  {
                    id: 21,
                    name: "Union Pension Fund"
                  },
                  {
                    id: 22,
                    name: "University (Non-Endowment)"
                  },
                  {
                    id: 23,
                    name: "Family Office (Single)"
                  },
                  {
                    id: 24,
                    name: "High-net-worth Investor"
                  },
                  {
                    id: 25,
                    name: "Discretionary Advisor"
                  },
                  {
                    id: 26,
                    name: "Other Limited Partner"
                  },
                  {
                    id: 27,
                    name: "Institutional Investor"
                  }
              ],
                investment_structures : [
                    {
                      id: 1,
                      name: "Direct Deal Investment"
                    },
                    {
                      id: 2,
                      name: "Fund Investment"
                    }
                ],
                labels : [
                  {
                    id: 1,
                    name: "Close Relationship"
                  },
                  {
                    id: 2,
                    name: "USE AN OCIO"
                  },
                  {
                    id: 3,
                    name: "DON'T CONTACT"
                  },
                  {
                    id: 4,
                    name: "INACTIVE"
                  },
                  {
                    id: 5,
                    name: "SUBMIT PROPOSALS THROUGH PORTAL"
                  },
                  {
                    id: 6,
                    name: "WANT TO BE APPROACHED"
                  }
                ],
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/investors');
            }
            this.prerequisite();

        },
        methods: {
          prerequisite(){
            axios.get('/api/user/profile/questionnaire/pre-requisite')
                .then(response => response.data)
                .then(response => {
                  this.fund_categories  = response.fund_categories;
                  this.fund_types       = response.fund_types;
                  this.continents       = response.continents;
                  this.regions          = response.regions;
                  this.countries        = response.countries;
                  this.currencies       = response.currencies;
                  this.investor_preferred_fund_types = response.investor_preferred_fund_types;
                  this.fetchInvestorData();
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          onHQCountrySelect(selectedOption){
            this.investorForm.errors.clear('hq_country');
            this.hq_country.push(selectedOption.id);
          },
          onHQCountryRemove(removedOption){
            this.hq_country.splice(this.hq_country.indexOf(removedOption.id), 1);
          },
          onHQGlobalRegionSelect(selectedOption){
            this.investorForm.errors.clear('hq_global_region');
            this.hq_global_region.push(selectedOption.id);
          },
          onHQGlobalRegionRemove(removedOption){
            this.hq_global_region.splice(this.hq_global_region.indexOf(removedOption.id), 1);
          },
          onHQGlobalSubRegionSelect(selectedOption){
            this.investorForm.errors.clear('hq_global_sub_region');
            this.hq_global_sub_region.push(selectedOption.id);
          },
          onHQGlobalSubRegionRemove(removedOption){
            this.hq_global_sub_region.splice(this.hq_global_sub_region.indexOf(removedOption.id), 1);
          },
          onPreferredGeographySelect(selectedOption){
            this.investorForm.errors.clear('preferred_geography');
            this.preferred_geography.push(selectedOption.id);
          },
          onPreferredGeographyRemove(removedOption){
            this.preferred_geography.splice(this.preferred_geography.indexOf(removedOption.id), 1);
          },
          onInvestmentStructureSelect(selectedOption){
            this.investorForm.errors.clear('investment_structure');
            this.investment_structure.push(selectedOption.id);
          },
          onInvestmentStructureRemove(removedOption){
            this.investment_structure.splice(this.investment_structure.indexOf(removedOption.id), 1);
          },
          onInvestorPreferredFundTypeSelect(selectedOption){
            this.investorForm.errors.clear('preferred_fund_type_organization');
            this.preferred_fund_type_organization.push(selectedOption.id);
          },
          onInvestorPreferredFundTypeRemove(removedOption){
            this.preferred_fund_type_organization.splice(this.preferred_fund_type_organization.indexOf(removedOption.id), 1);
          },
          onLimitedPartnerTypeOrganizationSelect(selectedOption){
            this.investorForm.errors.clear('limited_partner_type_organization');
            this.limited_partner_type_organization.push(selectedOption.id);
          },
          onLimitedPartnerTypeOrganizationRemove(removedOption){
            this.limited_partner_type_organization.splice(this.limited_partner_type_organization.indexOf(removedOption.id), 1);
          },

            fetchInvestorData(){
                axios.get('/api/investor/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.investor = response.investor;
                        this.investorForm.cp_first_name = response.investor.cp_first_name;
                        this.investorForm.cp_last_name = response.investor.cp_last_name;
                        this.investorForm.cp_email = response.investor.cp_email;
                        this.investorForm.cp_phone = response.investor.cp_phone;
                        this.investorForm.name = response.investor.name;
                        this.investorForm.website = response.investor.website;
                        this.investorForm.label = response.investor.label;

                        this.investorForm.esg = response.investor.esg;
                        this.investorForm.active = response.investor.active;
                        this.investorForm.fundtype = response.investor.fundtype;
                        this.investorForm.geography = response.investor.geography;
                        this.investorForm.hqcity = response.investor.hqcity;
                        this.investorForm.hqcontinent = response.investor.hqcontinent;
                        this.investorForm.hqcountry = response.investor.hqcountry;
                        this.investorForm.invstructure = response.investor.invstructure;
                        this.investorForm.irr = response.investor.irr;
                        this.investorForm.moic = response.investor.moic;
                        this.investorForm.period = response.investor.period;
                        this.investorForm.summary = response.investor.summary;
                        this.investorForm.ticketsize = response.investor.ticketsize;
                        this.investorForm.inv_struct = response.investor.invstructure;
                        this.investorForm.policy_description = response.investor.policy_description;
                        this.investorForm.description = response.investor.description;

                        this.investorForm.esg_status = response.investor.esg_status;
                        this.investorForm.fund_first_time = response.investor.fund_first_time;
                        this.investorForm.holding_period = response.investor.holding_period; // Math.round((response.investor.holding_period_from + response.investor.holding_period_from) / 2);
                        this.investorForm.ticket_size = response.investor.ticket_size;
                        this.investorForm.preferred_fund_type = response.investor.preferred_fund_type;
                        // this.investorForm.preferred_geography = response.investor.preferred_geography;
                        this.investorForm.content = response.investor.content;
                        this.investorForm.preferred_commitment_size = response.investor.preferred_commitment_size;
                        // this.investorForm.limited_partner_type_organization = response.investor.limited_partner_type_organization;
                        // this.investorForm.investment_structure = response.investor.investment_structure;
                        this.investorForm.open_to_first_time_funds = response.investor.open_to_first_time_funds;
                        // this.investorForm.preferred_fund_type_organization = response.investor.preferred_fund_type_organization;

                        this.investorForm.commitments = response.investor.commitments;
                        this.investorForm.commitments_in_re_funds = response.investor.commitments_in_re_funds;
                        this.investorForm.commitments_in_vc_funds = response.investor.commitments_in_vc_funds;
                        this.investorForm.commitments_in_infrastructure = response.investor.commitments_in_infrastructure;
                        this.investorForm.commitments_in_pe_funds = response.investor.commitments_in_pe_funds;
                        this.investorForm.alternative_investments_perc = response.investor.alternative_investments_perc;
                        this.investorForm.real_estate_perc = response.investor.real_estate_perc;
                        this.investorForm.private_equity_perc = response.investor.private_equity_perc;
                        this.investorForm.alternative_investments_amn = response.investor.alternative_investments_amn;
                        this.investorForm.real_estate_amn = response.investor.real_estate_amn;
                        this.investorForm.private_equity_amn = response.investor.private_equity_amn;
                        this.investorForm.number_of_employees = response.investor.number_of_employees;
                        this.investorForm.irr_perc = response.investor.irr_perc;

                        this.investorForm.fund_status = response.investor.fund_status;
                        this.investorForm.assets_under_management = response.investor.assets_under_management;
                        this.investorForm.hq_city = response.investor.hq_city;
                        // this.investorForm.hq_country = response.investor.hq_country;
                        // this.investorForm.hq_global_sub_region = response.investor.hq_global_sub_region;
                        // this.investorForm.hq_global_region = response.investor.hq_global_region;

                        if(response.investor.hq_global_sub_region){
                          this.selected_hq_global_sub_regions    = response.investor.hq_global_sub_region;
                        }else{
                          this.selected_hq_global_sub_regions    = [];
                        }

                        if(response.investor.hq_country){
                          this.selected_hq_countries    = response.investor.hq_country;
                        }else{
                          this.selected_hq_countries    = [];
                        }
                        if(response.investor.hq_global_region){
                          this.selected_hq_global_regions    = response.investor.hq_global_region;
                        }else{
                          this.selected_hq_global_regions    = [];
                        }

                        if(response.investor.preferred_geography){
                          this.selected_preferred_geographies    = response.investor.preferred_geography;
                        }else{
                          this.selected_preferred_geographies    = [];
                        }

                        if(response.investor.investment_structure){
                          this.selected_investment_structures    = response.investor.investment_structure;
                        }else{
                          this.selected_investment_structures    = [];
                        }

                      if(response.investor.limited_partner_type_organization){
                        this.selected_limited_partner_type_organizations    = response.investor.limited_partner_type_organization;
                      }else{
                        this.selected_limited_partner_type_organizations    = [];
                      }



                        if(response.investor.preferred_fund_type_organization){
                          this.selected_preferred_fund_type_organizations    = response.investor.preferred_fund_type_organization;
                        }else{
                          this.selected_preferred_fund_type_organizations    = [];
                        }

                      })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/investor');
                    })
            },
            submit(){

              this.selected_hq_countries.forEach(function (item) {
                this.investorForm.hq_country.push(item.name);
              }.bind(this));

              this.selected_hq_global_regions.forEach(function (item) {
                this.investorForm.hq_global_region.push(item.name);
              }.bind(this));

              this.selected_hq_global_sub_regions.forEach(function (item) {
                this.investorForm.hq_global_sub_region.push(item.name);
              }.bind(this));

              this.selected_investment_structures.forEach(function (item) {
                this.investorForm.investment_structure.push(item.name);
              }.bind(this));

              this.selected_limited_partner_type_organizations.forEach(function (item) {
                this.investorForm.limited_partner_type_organization.push(item.name);
              }.bind(this));

              this.selected_preferred_fund_type_organizations.forEach(function (item) {
                this.investorForm.preferred_fund_type_organization.push(item.name);
              }.bind(this));

              this.selected_preferred_geographies.forEach(function (item) {
                this.investorForm.preferred_geography.push(item.name);
              }.bind(this));


                // this.investorForm.date_of_birth = (this.investorForm.date_of_birth) ? moment(this.investorForm.date_of_birth).format('YYYY-MM-DD') : null;
                // this.investorForm.date_of_anniversary = (this.investorForm.date_of_anniversary) ? moment(this.investorForm.date_of_anniversary).format('YYYY-MM-DD') : null;
                this.investorForm.patch('/api/investor/'+this.id)
                    .then(response => {
                        this.investorForm.hq_country = [];
                        this.investorForm.hq_global_region = [];
                        this.investorForm.hq_global_sub_region = [];
                        this.investorForm.investment_structure = [];
                        this.investorForm.limited_partner_type_organization = [];
                        this.investorForm.preferred_fund_type_organization = [];
                        this.investorForm.preferred_geography = [];
                        this.fetchInvestorData();
                        toastr.success(response.message);
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
        }
    }
</script>
